<template>
  <div v-if="scheduleServiceOptions && scheduleServiceOptions.length" class="mb-4 max-400">
    <div v-for="(item, index) in scheduleServiceOptions" :key="index" class="">
      <button :title="item.name" class="btn  mb-2 rounded-buttons mx-1 text-white chips__btn px-4 btn-block py-2"
        :class="[{ 'bgcolor-primary': !isGradient }, { 'transparent-bgcolor': isGradient }]" @click="optionclick(item)">
        {{ item.name }}
      </button>
    </div>
  </div>
</template>
<script>
import { ChatWidgetService } from '../../../../Services/ChatWidgetService/ChatWidgetService';

export default {
  // eslint-disable-next-line vue/require-prop-types
  props: ['botResponse', 'isLastIndex', 'chatThemeSettings',],
  data() {
    return {
      scheduleServiceOptions: [],
      primaryColor: window.primaryColor,
      isChecked: null,
      transparentColor: '',
      textColor: '#000'
    }
  },

  mounted() {

    if (this.botResponse?.component?.values?.length) {
      this.scheduleServiceOptions = this.botResponse?.component?.values;
    }
    if (this.chatThemeSettings?.primeColor) {
      this.primaryColor = this.chatThemeSettings.primeColor;
    }

    if (this.isGradient) {
      this.primaryColor = '#fff';
      this.transparentColor = 'rgba(0, 0, 0, 0.1) !important';
      this.textColor = '#fff';
    }

    console.log(this.botResponse, 'ccc')

  },
  methods: {
    optionclick(item, index) {
      ChatWidgetService.postTvmMessage(item.name, null, this.botResponse?.component?.submitFlow,
        this.botResponse?.component?.submitAction, null);
    },
  },
  computed: {
    isGradient() {
      return this.chatThemeSettings?.isGradient || false;
    },
  },

}
</script>
<style lang="less" scoped>
.max-400 {
  max-width: 450px;
}
</style>
